const getMesAvancoDataAtual = (mes) => {
    let data = new Date() ;
    data = new Date(data.getFullYear(), data.getMonth(), 1);
    data.setMonth(data.getMonth() + mes);
    const formatter = new Intl.DateTimeFormat('pt-BR', { month: 'long' });
    return formatter.format(data);
  }


export {
    getMesAvancoDataAtual
}